(function() {
  'use strict';

  function SideBarEventFiles(RouterHelperService, EventsApi) {
    return {
      restrict: 'A',
      templateUrl: 'app/components/events/cards/files.card.html',
      link: function(scope) {
        let params = RouterHelperService.getParams();
        scope.eventId = params.eventId;
        EventsApi.getEventFiles(scope.eventId)
        .then(function(files) {
          scope.model = files.map(file => file.fileinfo);
        });
      }
    };
  }

  SideBarEventFiles.$inject = ['RouterHelperService', 'EventsApiService'];

  angular.module('component.events')
    .directive('sidebarEventFiles', SideBarEventFiles);
})();
